import React from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Flex, Scrollbar, Text, Title} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {Record} from '../../../../stores/Form';
import {SelectedEntity} from '../../../../components/EditingDialog';
import {formatNumber} from '../.././../Form/utils/number';
import {isRTL} from '../../../../Localization';

type RoutesTotalsProps = {
    records: Array<Record>;
    totalsEntity: SelectedEntity;
};

type TotalItemProps = {
    fieldName: string;
    cols: priority.netitems.form.IColumn[];
    records: Array<Record>;
};

const getRecordValue = (record: Record, columnId: number): number => {
    const value = record.getField(columnId)?.Value;
    const res = value.Real || (value.Int as number) || value.Shifted || 0;
    return res;
};

const TotalItem = ({fieldName, cols, records}: TotalItemProps) => {
    const column = cols.find(c => c.Name === fieldName);
    const title = column.Title;
    const value = records.reduce(
        (acc, record) => acc + getRecordValue(record, column.ID as number),
        0
    );
    const decimal = column.Decimal || 0;
    const fieldValue = parseFloat(value.toFixed(decimal as number)).toString();
    const res = formatNumber(fieldValue);
    return (
        <Flex direction="column" componentClasses={styles.totalItem}>
            <Title skin="h4" text={res} />
            <Text skin="paragraph-2">{title}</Text>
        </Flex>
    );
};

export const RoutesTotals = ({records, totalsEntity}: RoutesTotalsProps) => {
    const {cols, selectedFields} = totalsEntity;

    return (
        <Scrollbar autoHeight autoHide rtl={isRTL()}>
            <div dir="ltr">
                <Flex
                    direction="row-reverse"
                    justifyContent="flex-start"
                    componentClasses={styles.routesTotalWrapper}
                >
                    {selectedFields.map(field => {
                        return (
                            <TotalItem
                                key={field}
                                fieldName={field}
                                cols={cols}
                                records={records}
                            />
                        );
                    })}
                </Flex>
            </div>
        </Scrollbar>
    );
};
